export default __webpack_public_path__ + "static/media/minus-icon.0bc57cc7.svg";